import React from 'react';

const TextArea = ({ classname, name, placeholder, onChange, value }) => {
  return <textarea className={classname} name={name} value={value} onChange={onChange} placeholder={placeholder} />;
};

export default TextArea;
